import request from './request.js';
// TBEmployee
export default {
	// 添加/操作权限
	addAllpower(params) {
		return request({
			url: '/TBEmployee/AddMenuAction',
			method: 'post',
			data: params
		})
	},
	// 查询权限编号是否存在
	getMenuCode(params) {
		return request({
			url: `/TBEmployee/ExistsMenuActionCode${params}`,
			method: 'post'
		})
	},
	// 查询所有权限
	getAllMenuAction() {
		return request({
			url: '/TBEmployee/GetAllMenuAction',
			method: 'post'
		})
	},
	// 查询所有角色信息
	getAllRole() {
		return request({
			url: '/TBEmployee/GetAllRole',
			method: 'post'
		})
	},
	// 添加/修改角色信息
	setRole(params) {
		return request({
			url: '/TBEmployee/SetRole',
			method: 'post',
			data: params
		})
	},
	// 判断角色名称是否存在
	judRoleName(params) {
		return request({
			url: `/TBEmployee/ExistsRoleName${params}`,
			method: 'post'
		})
	},
	// 删除角色
	delRoleMsg(params) {
		return request({
			url: `/TBEmployee/DeleteRole${params}`,
			method: 'post'
		})
	},
	
	// 添加员工角色
	setEmployeeRole(data){
		let {jobNumber,roleId} = data;
		return request({
			url: `/TBEmployee/AddEmployeeRole?jobNumber=${jobNumber}&roleId=${roleId}`,
			method: "post"
		})
	},
	// 删除员工角色
	delEmplooyeeRole(data){
		let {jobNumber,roleId} = data;
		return request({
			url: `/TBEmployee/DeleteEmplooyeeRole?jobNumber=${jobNumber}&roleId=${roleId}`,
			method: "post"
		})
	},
	// 获取员工角色
	getEmplooyeeRole(data){
		return request({
			url: `/TBEmployee/QueryEmployeePermission?jobNumber=${data}`,
			method: "post"
		})
	},
	
}
